import {
  SET_CURRENT_PICKLIST,
  SET_PICKLIST_DETAILS_ASSETS_COUNTING,
  SET_PICKLIST_DETAILS_STATUSES,
  SET_PICKLIST_DETAILS_PICKLIST_ASSETS,
  SET_PICKLIST_DETAILS_PICKLIST_LOOSE_ITEMS,
  SET_PICKLIST_DETAILS_PICKLIST_ASSEMBLIES,
  SET_PICKLIST_DETAILS_FILTER,
  SET_PICKLIST_DETAILS_FILTER_CRITERIA,
  CLEAR_PICKLIST_DETAILS_STATE
} from 'constants/reduceConstants';

const initialState = {
  currentPicklist: {},
  picklistStatuses: [],
  assetsCounting: {
    slicedPicklistAssets: [],
    total: {}
  },
  assets: [],
  looseItems: [],
  assemblies: [],
  selectedRows: [],
  filter: {},
  criteria: {}
};

const picklistDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Info
    case SET_CURRENT_PICKLIST:
      return { ...state, currentPicklist: payload };
    case SET_PICKLIST_DETAILS_ASSETS_COUNTING:
      return { ...state, assetsCounting: payload };
    case SET_PICKLIST_DETAILS_STATUSES:
      return { ...state, picklistStatuses: payload };
    // Table
    case SET_PICKLIST_DETAILS_PICKLIST_ASSETS:
      return { ...state, assets: payload };
    case SET_PICKLIST_DETAILS_PICKLIST_LOOSE_ITEMS:
      return { ...state, looseItems: payload };
    case SET_PICKLIST_DETAILS_PICKLIST_ASSEMBLIES:
      return { ...state, assemblies: payload };
    // Filter
    case SET_PICKLIST_DETAILS_FILTER:
      return { ...state, filter: payload };
    case SET_PICKLIST_DETAILS_FILTER_CRITERIA:
      return { ...state, criteria: payload };
    // Unmount
    case CLEAR_PICKLIST_DETAILS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default picklistDetailsReducer;
